/**
 * The "Report a bug" link in every page's footer: Bug Report with the page
 * filled in. The page keeps only the query values that say which poll,
 * schedule or excerpt it was (p, s, id). Everything else is left out, since
 * a query can hold a creator key, a link key or a token, and the report goes
 * to Discord. Tested by tests/bugreport.test.mjs.
 */

const KEPT_PARAMS = ['p', 's', 'id'] as const;

/** The page as a bug report should name it: its path, plus any poll, schedule or excerpt id. */
export function reportablePage(pathname: string, search: string): string {
  const params = new URLSearchParams(search);
  const kept = new URLSearchParams();
  for (const name of KEPT_PARAMS) {
    const value = params.get(name);
    if (value && /^[A-Za-z0-9_-]{1,64}$/.test(value)) kept.set(name, value);
  }
  const query = kept.toString();
  return query ? `${pathname}?${query}` : pathname;
}

/** The Bug Report link for a page. */
export function bugReportHref(page: string): string {
  return `/bugreport?page=${encodeURIComponent(page)}`;
}
